import ITexts from "./ITexts";

const en: ITexts = {
  project_updates_not_found: "No Updates found."
};

export default en;
